<template>
  <main class="app-main">
    <router-view />
  </main>
  <app-footer class="app-footer" />
</template>

<script>
import AppFooter from "./components/app/AppFooter.vue";
export default {
  components: { AppFooter },
  name: "App",
};
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
}
.app-footer {
  margin-top: auto;
}
</style>
